import React, { lazy } from 'react';

const ProAndAuthListing = lazy(() =>
  import(
    'containers/SystemAdminModule/AccessSecurityModule/ProjectRoleAuthModule/ProAndAuthListing'
  ).then(module => ({
    default: module.ProAndAuthListing,
  })),
);

const ProAndAuthRoleAssignmentListing = lazy(() =>
  import(
    'containers/SystemAdminModule/AccessSecurityModule/ProjectRoleAuthModule/ProAndAuthRoleAssignmentListing'
  ).then(module => ({
    default: module.ProAndAuthRoleAssignmentListing,
  })),
);
const ProAndAuthRoleForm = lazy(() =>
  import(
    'containers/SystemAdminModule/AccessSecurityModule/ProjectRoleAuthModule/ProAndAuthRoleForm'
  ).then(module => ({
    default: module.ProAndAuthRoleForm,
  })),
);

export const projectRoleAuthRoutes = [
  {
    props: {
      exact: true,
      path: '/access-security/project-auth',
    },
    component: <ProAndAuthListing software="Contract" />,
  },

  {
    props: {
      exact: true,
      path: '/access-security/project-auth/:contractID/role-assignment',
    },
    component: <ProAndAuthRoleAssignmentListing software="Contract" />,
  },
  {
    props: {
      exact: true,
      path:
        '/access-security/project-auth/:contractID/role-assignment/:roleID/form',
    },
    component: <ProAndAuthRoleForm software="Contract" />,
  },
];
